import {gql} from '@apollo/client'

export const GET_WINE_CLUB_MEMBERSHIPS = gql`
  query getWineClubMembership(
    $name: String
    $orderBy: String
    $offset: Int!
    $pageSize: Int!
    $fromDate: Datetime
    $toDate: Datetime
  ) {
    searchSubscriptions(
      offset: $offset
      name: $name
      filter: {
        wineClubId: {isNull: false}
        createdAt: {greaterThanOrEqualTo: $fromDate, lessThanOrEqualTo: $toDate}
      }
      orderBy: $orderBy
      first: $pageSize
    ) {
      nodes {
        id
        createdAt
        customer {
          firstName
          lastName
        }
        subscriptionOrderSchedules {
          nodes {
            lastOrderDate
            nextOrderDate
          }
        }
        wineClub {
          name
          frequency
        }
      }
      totalCount
    }
  }
`
